import styled from "styled-components";

export const LogoStyle = styled.figure`
  z-index: 2;
  margin: 0;
  position: relative;
`;
